export enum ComplexDatepickerTimezoneEnum {
  BROWSER = 'BROWSER',
  SERVER = 'SERVER',
  UTC = 'UTC',
}
